export default (state) => {
    return state.enquiry;
}



// WEBPACK FOOTER //
// ./src/ReduxRequests/State/enquiryState.ts